<script setup>

import {onMounted, ref} from "vue";

const props = defineProps({
    title: {
        type: String,
        required: false,
        default: null
    },
    publishedAt: {
        type: String,
        required: false,
        default: null,
    },
    containerRef: {
        type: String,
        required: true,
    },
    content: {
        type: Object,
        required: true,
    },
    design: {
        type: Object,
        required: true,
    }
})

const backlinkAvailable = ref(null);

const navigateBack = () => {
    window.history.back();
}

onMounted(() => {
    backlinkAvailable.value = window.history.length > 1;
})

</script>
<template>
    <div>
        <div class="text-center pt-6 pb-4">
            <h1>{{ props.title }}</h1>
            <div class="my-1 text-sm text-gray-400">{{ props.publishedAt }}</div>
        </div>

        <page-builder-view
            :container-ref="props.containerRef"
            :content="props.content"
            :design="props.design"
        ></page-builder-view>

        <div
            v-if="backlinkAvailable"
            class="my-4 text-center flex justify-center"
        >
            <span @click="navigateBack" class="flex items-center space-x-1 mf-link-immune text-gray-600 cursor-pointer">
                <i class="fa-regular fa-arrow-left text-xs"></i>
                <span>{{ _mft('shared:navigation.back') }}</span>
            </span>
        </div>
    </div>
</template>
